import zh from './zh'
import en from './en'

export default {
   zh,
   en 
}; //将i18n暴露出去，在main.js中引入挂载


// WEBPACK FOOTER //
// ./src/lang/index.js